import React, { Component } from 'react'
import {ButtonContainer} from '../Button/Button'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'
import {addToCart} from '../../actions/cart_Action'
import {Row,Col} from 'react-bootstrap'
import Sidebar from '../Sidebar'
import SweetAlert from 'react-bootstrap-sweetalert'
import './Details.css'
const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}


class Details extends Component {
  
    constructor(props) {
      super(props);
  
      this.state = {
        alert: null
      };
    } 
  
    handleAlert() {
      const getAlert = () => (
        <SweetAlert 
          success 
          title="Woot!" 
          onConfirm={() => this.hideAlert()}
        >
         <h5 id ="styling-title"> Item Successfully Added to Cart!</h5>
        </SweetAlert>
      );
  
      this.setState({
        alert: getAlert()
      });
    }
  
    hideAlert() {
      console.log('Hiding alert...');
      this.setState({
        alert: null
      });
    }

  handleClick = (key)=>{
      
    this.props.addToCart(key);
   
    sleep(500).then(() => {
      this.handleAlert()
       })
    
    }
  
  render() {

    let itemList = this.props.detailItem.map(item=>{
          // return console.log() 
          return(
      <> 
      
      <div className="container py-5">
      <div className="row">
        <div className="col-10 mx-auto text-center text-slanted text-blue my-5">
        <h1>{item.p_name}</h1> 
        </div>
      </div>

      {/* Product info*/}
      <div className="row">
      <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
      <img src={item.img} className="img-fluid" alt= "product"/>
      </div>
       {/* Product text*/}
       <div className="col-10 mx-auto col-md-6 my-3 text-capitalize">
       <h2>{item.category}:{item.p_name}</h2>
       <h4 className="text-title text-uppercase text-muted mt-3 mb-2">
       made by:<span className="text-uppercase">
       company</span>
       </h4>
       <h4 className="text-blue">
       <strong>
         price:<span></span>
         {item.price}
         </strong>
       </h4>
       <p className="text-capitalize font-weight-bold mt-3 mb-0">
       some info about product:
       </p>
       <p className="text-muted lead">{item.info}</p>
       {/*buttons */}
      
       {/* <div style={{ padding: '20px' }}>
          <a 
            onClick={() => this.deleteThisGoal()}
            className='btn btn-danger'
          >
            <i className="fa fa-trash" aria-hidden="true"></i> Delete Goal
        </a>
        {this.state.alert}
      </div> */}

      
       <div>



       <Link to ="/">
         <ButtonContainer>
           back to shopping
         </ButtonContainer>
         </Link>

         <Link to ="/cart">
         <ButtonContainer>
           go to cart
         </ButtonContainer>
         </Link>
         
        
         <ButtonContainer   disabled={item.inCart ?true:false } onClick={()=>{
        this.handleClick(item.key)             
       }}>
          {item.inCart ?(<p className="text-capitalize mb-0" disabled>in the cart</p>) : <p className="text-capitalize mb-0">add to cart</p>}

         </ButtonContainer>
         {this.state.alert}
         </div>
       </div> 
       </div>
       </div>              
     
    </>           
          )
      })
    
      return(
          
        <div className="container-fluid">
      
              <Row>
                
            <Col sm={3}>
              <Sidebar />
            </Col>
            <Col sm={9}>
                  {itemList}
                  </Col>
             
              </Row>
          </div>
          
      )
      
  }
}

const mapStateToProps = (state)=>{
    
  return {
    detailItem:state.detailItem,
 
  }
}

const mapDispatchToProps= (dispatch)=>{
  
  return{
      addToCart: (key)=>{dispatch(addToCart(key))},
      
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Details)
